/**
 * @generated SignedSource<<84a27823c0d5f2ef0c764aade4a8cff0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarouselLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_item">;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarouselLazy_item";
};
export type PdpSharedVisuallySimilarItemsCarouselLazy_item$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarouselLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarouselLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedVisuallySimilarItemsCarouselLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarousel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5e834b10f251708e584f9db5ef87de85";

export default node;
